import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class MessagingService {

  public messageSubject: Subject<any> = new BehaviorSubject<any>(null);
  public modalTitleSubject: Subject<any> = new BehaviorSubject<any>(null);

  constructor() {
  }

  sendMessage(val) {
    this.messageSubject.next(val);
  }

  setModalTitle(text) {
    this.modalTitleSubject.next(text);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/messaging.service.ts